import React, { useState } from 'react';
import { connect } from 'react-redux';
import HeroSection from 'components/landing/HeroSection';
import BenefitSection from 'components/landing/BenefitSection';
import LearningLogSection from 'components/landing/LearningLogSection';
import PricingSection from 'components/landing/PricingSection';
import DownloadSection from 'components/landing/DownloadSection';
import Footer from 'components/landing/Footer';
import MainHeader from '../../components/landing/MainHeader';
import SideMenu from '../../components/landing/SideMenu';

function Landing(props) {

  const [sideOpen, setSideOpen] = useState(false)

  const onSignInClick = (e) => {
    e.preventDefault();
    props.history.push('/signin')
  }

  return (
    <>
      <div id="landing">

        <MainHeader
          sideOpen={sideOpen}
          setSideOpen={setSideOpen}
          onSignInClick={onSignInClick} />
        <SideMenu
          setSideOpen={setSideOpen}
          sideOpen={sideOpen} />
        <HeroSection />
        <BenefitSection />
        <LearningLogSection />
        <PricingSection />
        <DownloadSection />
        <Footer />
      </div>
    </>
  );
}

export default connect(null, {})(Landing);